// Imports
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
	faCalendar,
	faChartPie,
	faImages,
	faMoneyBill1Wave,
	faNewspaper,
	faUserGear,
	faChartMixed,
	faCircleQuestion,
	faEnvelope,
	faEarthAmericas,
	faSquareCheck,
	faBan,
	faAt,
	faCubes,
	faScreenUsers,
	faMailbox,
	faCopy,
	faLock,
	faFiles,
	faAlignLeft,
	faUserTie,
	faCloud,
	faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import planMapping from '../../utils/billing/plan-mapping';
import planNameMapping from '../../utils/billing/plan-name-mapping';


// Define what a plan looks like
export interface Plan {
	name: string;
	planNumber: number;
	description?: string;
	backgroundColor: string;
	accentColor: string;
	features: {
		label?: string;
		features: {
			text: string;
			icon: IconDefinition;
		}[];
	};
}


// Shared feature set
const deluxeFeatureSet: Plan['features']['features'] = [
	{ text: 'Blast emails & texts', icon: faEnvelope },
	{ text: 'Professional email accounts', icon: faAt },
	{ text: 'Multiple website admins', icon: faUserGear },
	{ text: 'Collect payments online', icon: faMoneyBill1Wave },
	{ text: 'Custom forms', icon: faCubes },
	{ text: 'Surveys & polls', icon: faChartPie },
	{ text: 'Groups of residents', icon: faScreenUsers },
	{ text: 'Mailed letters', icon: faMailbox },
];


// Paid plans
const informPlan: Plan = {
	name: planNameMapping[planMapping.inform],
	planNumber: planMapping.inform,
	description: 'Robust features for informing your community',
	backgroundColor: 'hsl(96, 69%, 87%)',
	accentColor: 'hsl(96, 69%, 35%)',
	features: {
		label: 'Everything in Free, plus:',
		features: [
			{ text: 'Custom domain', icon: faEarthAmericas },
			{ text: 'Resident & pet directories', icon: faUsers },
			{ text: 'Visitor tracking', icon: faChartMixed },
			{ text: 'Photo galleries', icon: faImages },
			{ text: 'FAQs', icon: faCircleQuestion },
			{ text: 'Community facilities', icon: faSquareCheck },
			{ text: 'No ads', icon: faBan },
		],
	},
};

const grandfatheredDeluxePlan: Plan = {
	name: `Legacy ${planNameMapping[planMapping.grandfatheredDeluxe]}`,
	planNumber: planMapping.grandfatheredDeluxe,
	backgroundColor: 'hsl(0, 0%, 87%)',
	accentColor: 'hsl(0, 0%, 35%)',
	features: {
		label: 'Everything in Inform, plus:',
		features: deluxeFeatureSet,
	},
};

const engagePlan: Plan = {
	name: planNameMapping[planMapping.engage],
	planNumber: planMapping.engage,
	description: 'All-in-one platform for engaging with your community',
	backgroundColor: 'hsl(206, 70%, 88%)',
	accentColor: 'hsl(206, 69%, 35%)',
	features: {
		label: 'Everything in Inform, plus:',
		features: deluxeFeatureSet,
	},
};


// Free plan
const freePlan: Plan = {
	name: planNameMapping[planMapping.free],
	planNumber: planMapping.free,
	description: 'Basic features for small communities',
	backgroundColor: 'hsl(36, 100%, 90%)',
	accentColor: 'hsl(36, 44%, 52%)',
	features: {
		features: [
			{ text: 'Unlimited pages', icon: faCopy },
			{ text: 'Unlimited storage', icon: faCloud },
			{ text: 'Page restrictions', icon: faLock },
			{ text: 'Upload documents', icon: faFiles },
			{ text: 'Calendar events', icon: faCalendar },
			{ text: 'Board & committee info', icon: faUserTie },
			{ text: 'News articles', icon: faNewspaper },
			{ text: 'Rich text pages', icon: faAlignLeft },
		],
	},
};


// Subscription plans
const plansDetails = {
	legacyPlan: {
		grandfatheredDeluxePlan,
	},
	paidPlans: [informPlan, engagePlan],
	freePlan: freePlan,
};

export default plansDetails;
